import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalLayoutComponent } from '../../layout/principal-layout/principal-layout.component';
import { KeywordsComponent } from './keywords.component';

const routes: Routes = [
  {
    path: 'keywords',
    component: PrincipalLayoutComponent,
    children: [
      { path: '', component: KeywordsComponent },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KeywordsRoutingModule { }
